module.exports = __webpack_public_path__ + "media/images/flavours/icon-compote_dark-a4718d17a156f9772624e9968e032bce.png";